import { useConsultsLeft } from "@/features/appointments/hooks/useConsultsLeft"
import { useGetAppointments } from "@/features/appointments/hooks/useGetAppointments"
import { useAdmin } from "@/features/experts/hooks/useAdmin"
import { usePhysician } from "@/features/experts/hooks/usePhysician"
import { useSpecialist } from "@/features/experts/hooks/useSpecialist"
import { useGetHealthPlan } from "@/features/health-plan/hooks/useGetHealthPlan"
import { useBloodTracker } from "@/features/holifya-tests/blood-test/hooks/useBloodTracker"
import { useDnaTracker } from "@/features/holifya-tests/dna-test/hooks/useDnaTracker"
import { useGetMealPlans } from "@/features/meal-plan/hooks/useGetMealPlans"
import { useGetMembership } from "@/features/membership/hooks/useGetMembership"
import { useGetProducts } from "@/features/products/hooks/useGetProducts"
import { useSurveyData } from "@/features/survey/hooks/useSurveyData"
import { useGetTutorial } from "@/features/tutorials/hooks/useGetTutorials"
import { useUserFiles } from "@/features/uploads/hooks/useUserFiles"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import LoadingSpinner from "../../../components/LoadingSpinner"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { useUserStore } from "../../../utils/stores/useUserStore"
import { useNutritionist } from "../../experts/hooks/useNutritionist"

const FetchData = () => {
    const { fetchDnaTracker } = useDnaTracker()
    const { fetchBloodTracker } = useBloodTracker()
    const { fetchNutritionist } = useNutritionist()
    const { fetchAdmin } = useAdmin()
    const { fetchPhysician } = usePhysician()
    const { fetchSpecialist } = useSpecialist()
    const { refetch: refetchAppointments } = useGetAppointments()
    const { fetchConsultsLeft } = useConsultsLeft()
    const { refetch: fetchMealPlan } = useGetMealPlans();
    const { refetch: fetchHealthPlan } = useGetHealthPlan();
    const { refetch: fetchMembership } = useGetMembership();
    const { fetchProducts } = useGetProducts();
    const { fetchSurveyData } = useSurveyData();
    const { fetchTutorial } = useGetTutorial();
    const { fetchUserFiles } = useUserFiles();

    const { auth } = useAuthStore()
    const { userData } = useUserStore()

    const { idToken, userId } = auth
    const { email } = userData

    const navigate = useNavigate()

    useEffect(() => {
        if (!idToken || !userId || !email) return

        const fetchData = async () => {
            try {
                // First fetch all expert data
                await Promise.all([
                    fetchBloodTracker(),
                    fetchDnaTracker(),
                    fetchNutritionist(),
                    fetchAdmin(),
                    fetchSpecialist(),
                    fetchPhysician()
                ])

                // Then fetch the rest of the data
                await Promise.all([
                    refetchAppointments(),
                    fetchConsultsLeft(),
                    fetchMealPlan(),
                    fetchHealthPlan(),
                    fetchMembership(),
                    fetchProducts(),
                    fetchSurveyData(),
                    fetchTutorial(),
                    fetchUserFiles(),
                ])
            } catch (error) {
                console.error("Error in FetchData:", error)
            } finally {
                navigate("/home")
            }
        }
        
        fetchData()
    }, [idToken, userId, email, fetchBloodTracker, fetchDnaTracker, fetchNutritionist, fetchAdmin, fetchSpecialist, fetchPhysician, refetchAppointments, fetchConsultsLeft, fetchMealPlan, fetchHealthPlan, fetchMembership, fetchProducts, fetchSurveyData, fetchTutorial, fetchUserFiles, navigate])

    // ********************************************************************************

    return (
        <div className="w-full h-screen flex flex-col items-center background-logo justify-center background-logo">
            <div className="flex flex-col bg-white w-[392px] m-[50px]">
                <div className="font-bold text-[30px] leading-[24px] self-center my-[20px] text-center">
                    Accesso in corso
                </div>
                <div className="font-normal text-[18px] leading-[26px] my-[20px] text-center self-center">
                    Stai per essere reindirizzato alla tua Area Riservata
                </div>
                <LoadingSpinner />
            </div>
        </div>
    )
}

export default FetchData
